import { Integration } from '@tagadapay/crm-entities'
import { z } from 'zod'

/**
 * The Slash API key is write-only: the CRM only ever receives it masked
 * (`••••••••ab12`). An empty field on save keeps the stored key.
 */
export const slashFormSchema = (hasSavedKey: boolean) =>
  z.object({
    apiKey: hasSavedKey ? z.string().trim() : z.string().trim().min(1, 'apiKeyRequired'),
    legalEntityId: z.string().trim(),
  })

export type SlashFormValues = z.infer<ReturnType<typeof slashFormSchema>>

const readString = (bag: unknown, key: string): string | null => {
  if (typeof bag !== 'object' || bag === null) return null
  const value: unknown = Reflect.get(bag, key)
  return typeof value === 'string' && value.length > 0 ? value : null
}

/** The masked key the CRM received, or null when none is saved yet. */
export const savedSlashKey = (credentials: unknown): string | null => {
  const apiKey = readString(credentials, 'apiKey')
  return apiKey && Integration.isMaskedSecret(apiKey) ? apiKey : null
}

/** The webhook URL the server registered on the merchant's Slash account, if any. */
export const registeredSlashWebhookUrl = (metadata: unknown): string | null =>
  readString(metadata, 'slashWebhookId') ? readString(metadata, 'slashWebhookUrl') : null

/** What the form sends: no `apiKey` when the field is left empty, so the server keeps the saved one. */
export const toSlashCredentials = (values: SlashFormValues): Record<string, string> => ({
  ...(values.apiKey.length > 0 ? { apiKey: values.apiKey } : {}),
  legalEntityId: values.legalEntityId,
})
